// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"PorositeUserit_containerDashboardP__Hei5s"};